<template>
    <div>
        <label :for="input.name">
            {{ input.label }}
        </label>
        <div
            class="form-control"
            :name="input.name"
            v-model="input.value"
        >
            Some date picker component...
        </div>
    </div>
</template>

<script>
export default {
    props: {
        input: {
            type: Object,
            required: true,
        },
    },
}
</script>
